import { MeasurementSystem, userStore } from "src/js/stores/user/store";

import { Icon } from "../Icon";
import { TextSwitch } from "../TextSwitch";
import { Tooltip } from "../Tooltip";
import { logEvent } from "react-migration/lib/util/logEvent";
import { mapStore } from "src/js/stores/map/store";
import { memo } from "react";
import saveUser from "src/js/stores/user/actions/saveUser";
import { setUnitPreference } from "src/js/stores/drawing/actions/setUnitPreference";
import { updateMeasurementSystemPreference } from "src/js/stores/user/actions/updateSetting";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

const UnitTypeToggleInner = memo(function UnitTypeToggle({ version = "old", itemClassName }: UnitTypeToggleProps) {
  const {
    user: {
      settings: { unit },
    },
  } = useSnapshot(userStore);
  const {
    settings: { activeLayer },
  } = useSnapshot(mapStore);
  const { t } = useTranslation();

  const updateUnitPreference = (v: string) => {
    updateMeasurementSystemPreference(v as MeasurementSystem);
    saveUser();
    setUnitPreference(v as MeasurementSystem);
    logEvent("Toggle Units", { unitType: v, layer: activeLayer });
  };

  if (version === "new") {
    return (
      <TextSwitch name="unit-preference" value={unit} hasBorder={false} className="">
        <Icon icon="icon-lt-ruler-2-line" extraClasses="pr-1" />
        <TextSwitch.Label value={MeasurementSystem.METRIC} onToggle={updateUnitPreference} className={itemClassName}>
          <Tooltip.Wrapper delayDuration={0}>
            <Tooltip.Content align="center" side="bottom" size="sm">
              {t("units.system.metric")}
            </Tooltip.Content>
            <Tooltip.Trigger>
              <div className="px-1">km</div>
            </Tooltip.Trigger>
          </Tooltip.Wrapper>
        </TextSwitch.Label>
        <TextSwitch.Label value={MeasurementSystem.IMPERIAL} onToggle={updateUnitPreference} className={itemClassName}>
          <Tooltip.Wrapper delayDuration={0}>
            <Tooltip.Content align="center" side="bottom" size="sm">
              {t("units.system.imperial")}
            </Tooltip.Content>
            <Tooltip.Trigger>
              <div className="px-1">mi</div>
            </Tooltip.Trigger>
          </Tooltip.Wrapper>
        </TextSwitch.Label>
      </TextSwitch>
    );
  }

  return (
    <TextSwitch name="unit-preference" value={unit} className="text-2xs!">
      <TextSwitch.Label value={MeasurementSystem.METRIC} onToggle={updateUnitPreference}>
        {t("units.system.metric")}
      </TextSwitch.Label>
      <TextSwitch.Label value={MeasurementSystem.IMPERIAL} onToggle={updateUnitPreference}>
        {t("units.system.imperial")}
      </TextSwitch.Label>
    </TextSwitch>
  );
});

interface UnitTypeToggleProps {
  version?: "new" | "old";
  itemClassName?: string;
}

export function UnitTypeToggle({ version = "old", itemClassName }: UnitTypeToggleProps) {
  return <UnitTypeToggleInner version={version} itemClassName={itemClassName} />;
}
